import { render, staticRenderFns } from "./CMAttachmentsImport.vue?vue&type=template&id=75d92078&scoped=true&"
import script from "./CMAttachmentsImport.vue?vue&type=script&lang=js&"
export * from "./CMAttachmentsImport.vue?vue&type=script&lang=js&"
import style0 from "./CMAttachmentsImport.vue?vue&type=style&index=0&id=75d92078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d92078",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75d92078')) {
      api.createRecord('75d92078', component.options)
    } else {
      api.reload('75d92078', component.options)
    }
    module.hot.accept("./CMAttachmentsImport.vue?vue&type=template&id=75d92078&scoped=true&", function () {
      api.rerender('75d92078', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/attachments/CMAttachmentsImport.vue"
export default component.exports